var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":_vm.forText}},[_vm._v(_vm._s(_vm.label)+"\n\t"),(_vm.helpText)?_c('span',{staticClass:"icg-calc__help"},[_c('span',{staticClass:"icg-calc__help-text"},[_vm._v(_vm._s(_vm.helpText))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }